<div class="sidebar-item-wrap">
    <p-button class="sidebar-btn" *ngFor="let button of buttons; let i = index" (click) = "openLink(button)" [attr.aria-label]="button.ariaLable">
        <div [ngClass]="{removeCursor:!button.link}">
        <img src="./assets/images/{{button.icon}}" alt="">
        <p>{{button.text}}</p>
        <span class="contact-phone" href="tel:*6552" *ngIf="button.text2" [ngClass]="{removeCursor:!button.link}">{{button.text2}}</span>
        </div>
    </p-button>
</div>    

